import { create } from 'zustand';
import api from '../lib/api';

export interface PermissionRoleSummary {
  id: string;
  name: string;
  label?: string;
  isSystem: boolean;
  isImmutable: boolean;
}

interface PermissionsState {
  loaded: boolean;
  isOwner: boolean;
  isSuperAdmin: boolean;
  permissions: Set<string>;
  disabledModules: Set<string>;
  roles: PermissionRoleSummary[];
  moduleSettings: Record<string, boolean>;
  refresh: () => Promise<void>;
  reset: () => void;
}

export const usePermissionsStore = create<PermissionsState>((set) => ({
  loaded: false,
  isOwner: false,
  isSuperAdmin: false,
  permissions: new Set(),
  disabledModules: new Set(),
  roles: [],
  moduleSettings: {},

  async refresh() {
    try {
      const res: any = await api.get('/auth/me/permissions');
      const d = res.data;
      set({
        loaded: true,
        isOwner: !!d.isOwner,
        isSuperAdmin: !!d.isSuperAdmin,
        permissions: new Set<string>(d.permissions || []),
        disabledModules: new Set<string>(d.disabledModules || []),
        roles: d.roles || [],
        moduleSettings: d.moduleSettings || {},
      });
    } catch {
      set({
        loaded: true,
        isOwner: false,
        isSuperAdmin: false,
        permissions: new Set(),
        disabledModules: new Set(),
        roles: [],
        moduleSettings: {},
      });
    }
  },

  reset() {
    set({
      loaded: false,
      isOwner: false,
      isSuperAdmin: false,
      permissions: new Set(),
      disabledModules: new Set(),
      roles: [],
      moduleSettings: {},
    });
  },
}));
